import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { UserGroup } from '../../model/user-group';
import { DataService } from './../../../core/service/base/data.service';
import { MessageService } from './../../../core/service/message.service';
import { ProgressBarService } from './../../../core/service/progress-bar.service';
import { Observable, catchError, map } from 'rxjs';
import { LocationAccessGroup } from '../../model/location-access-group';
import { Company } from '../../../rent/model/company';
import { Property } from '../../../rent/model/property';

@Injectable()
export class LocationAccessGroupService extends DataService<LocationAccessGroup> {
  constructor(
    private _client: HttpClient,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(_client, _config, messageService, LocationAccessGroup, progressBar, 'location-access-group');
  }

  getFilterDefinition(): Observable<{
    nameContains: string;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client
      .get<any>(`${this.endpoint}/filter`)
      .pipe(
        map(res => {
          return {
            nameContains: res.nameContains ? res.nameContains : '',
            selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : ['nameContains'],
            defaultFields: ['nameContains'],
          };
        })
      )
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }

  getAllCompanies(): Observable<Company[]> {
    return this.client.get<any[]>(`${this.endpoint}/companies-global`).pipe(
      map(res => res.map(r => Object.assign(new Company(), r))),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  getAllProperties(): Observable<Property[]> {
    return this.client.get<any[]>(`${this.endpoint}/properties-global`).pipe(
      map(res => res.map(r => Object.assign(new Property(), r))),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }

  getAccessControlStatus(): Observable<boolean> {
    return this.client
      .get<any>(`${this.endpoint}/access-control-status`)
      .pipe(map(res => res.active))
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }
}
